"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getKeyboardShortcutKeys = exports.getKeyboardShortcutKey = void 0;
var KEY_CODE_MAP = {
    8: 'Backspace',
    27: 'Escape',
    32: 'Space',
    37: 'ArrowLeft',
    38: 'ArrowUp',
    39: 'ArrowRight',
    40: 'ArrowDown',
    122: 'F11',
    187: '=',
    189: '-',
    191: '/',
    219: '[',
    221: ']',
};
var KEY_MAP = {
    ' ': 'Space',
    Spacebar: 'Space',
    Esc: 'Escape',
    Left: 'ArrowLeft',
    Up: 'ArrowUp',
    Right: 'ArrowRight',
    Down: 'ArrowDown',
};
var keyFromKeyCode = function (keyCode) {
    if (KEY_CODE_MAP[keyCode]) {
        return KEY_CODE_MAP[keyCode];
    }
    if (keyCode >= 48 && keyCode <= 57) {
        return String.fromCharCode(keyCode);
    }
    if (keyCode >= 65 && keyCode <= 90) {
        return String.fromCharCode(keyCode);
    }
    if (keyCode >= 96 && keyCode <= 105) {
        return String(keyCode - 96);
    }
    return null;
};
var normalizeKeyboardKey = function (_a) {
    var _b, _c;
    var key = _a.key, keyCode = _a.keyCode, which = _a.which;
    var mappedKey = (_b = KEY_MAP[key]) !== null && _b !== void 0 ? _b : key;
    if (mappedKey && mappedKey !== 'Unidentified') {
        return mappedKey.length === 1 ? mappedKey.toUpperCase() : mappedKey;
    }
    return (_c = keyFromKeyCode(keyCode || which)) !== null && _c !== void 0 ? _c : mappedKey;
};
var getKeyboardShortcutKey = function (event) {
    return event.code && event.code !== 'Unidentified' ? event.code : normalizeKeyboardKey(event);
};
exports.getKeyboardShortcutKey = getKeyboardShortcutKey;
var getKeyboardShortcutKeys = function (event) {
    var normalizedKey = normalizeKeyboardKey(event);
    var code = event.code !== 'Unidentified' ? event.code : '';
    return code && code !== normalizedKey ? [code, normalizedKey] : [normalizedKey];
};
exports.getKeyboardShortcutKeys = getKeyboardShortcutKeys;
